import { render, staticRenderFns } from "./AppButton.vue?vue&type=template&id=b0944138&scoped=true&"
import script from "./AppButton.vue?vue&type=script&lang=ts&"
export * from "./AppButton.vue?vue&type=script&lang=ts&"
import style0 from "./AppButton.vue?vue&type=style&index=0&id=b0944138&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0944138",
  null
  
)

export default component.exports